export default __webpack_public_path__ + "static/sp-progressbar-d8ae693ed44d200ed42c65bff1ef026b.png";